"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchChangeOnlineAccountPasswordV1 = exports.postResetOnlineAccountPasswordV2 = exports.getOnlineAccountV2 = exports.patchOnlineAccountV2 = exports.patchUnblockOnlineAccountV2 = exports.postResendActivationcodeV2 = exports.deleteOnlineAccountCustomerV1 = exports.postOnlineAccountCustomersV1 = exports.getOnlineAccountsV2 = exports.postOnlineAccountV1 = exports.deleteOnlineAccountV1 = void 0;
/**
 * This Service will delete the online account based on the given input
 * @param data The data for the request.
 * @param data.onlineAccountId Online Account Id of the consumer
 * @returns void OK
 * @throws ApiError
 */
const deleteOnlineAccountV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'DELETE',
        url: '/consumer/onlineaccount/v1',
        query: {
            online_account_id: data.onlineAccountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            409: '',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.deleteOnlineAccountV1 = deleteOnlineAccountV1;
/**
 * This Service will create the online account based on the given input
 * @param data The data for the request.
 * @param data.requestBody
 * @returns OnlineAccount OK
 * @throws ApiError
 */
const postOnlineAccountV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/consumer/onlineaccount/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            409: '',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postOnlineAccountV1 = postOnlineAccountV1;
/**
 * This Service retrieves the summary of none, one or mulitiple online account details
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account
 * @param data.email Email address of the online account
 * @param data.status Status of the online account
 * @param data.groupName group which customer account belongs for an online account
 * @returns GetOnlineAccountsResponse OK
 * @throws ApiError
 */
const getOnlineAccountsV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/consumer/onlineaccounts/v2',
        query: {
            account_id: data.accountId,
            email: data.email,
            status: data.status,
            group_name: data.groupName
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getOnlineAccountsV2 = getOnlineAccountsV2;
/**
 * This service will create customers for the online account based on the given input
 * @param data The data for the request.
 * @param data.onlineAccountId Online Account Id of the consumer
 * @param data.requestBody
 * @param data.isBlockRequired Flag to specify if Block call is required while adding customers to a debtmanager or a SME master account. (For DebtManager this field will be true and for SME this field will be false)
 * @returns OnlineAccount OK
 * @throws ApiError
 */
const postOnlineAccountCustomersV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/consumer/onlineaccount/{online_account_id}/customers/v1',
        path: {
            online_account_id: data.onlineAccountId
        },
        query: {
            is_block_required: data.isBlockRequired
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            410: 'gone',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postOnlineAccountCustomersV1 = postOnlineAccountCustomersV1;
/**
 * This Service will remove the customer from the online account based on the given input
 * @param data The data for the request.
 * @param data.onlineAccountId Online Account Id of the consumer
 * @param data.accountId The business partner id of the account
 * @param data.isUnblockRequired Flag to specify if unblock call is required while removing customer from a debtmanager or a SME master account.(For DebtManager this field will be true and for SME this field will be false
 * @returns void OK
 * @throws ApiError
 */
const deleteOnlineAccountCustomerV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'DELETE',
        url: '/consumer/onlineaccount/{online_account_id}/customers/v1',
        path: {
            online_account_id: data.onlineAccountId
        },
        query: {
            account_id: data.accountId,
            is_unblock_required: data.isUnblockRequired
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            409: '',
            410: 'gone',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.deleteOnlineAccountCustomerV1 = deleteOnlineAccountCustomerV1;
/**
 * This Service resents the activation code by sending the activation link to the customers email
 * @param data The data for the request.
 * @param data.onlineAccountId Online Account Id of the consumer
 * @returns void OK
 * @throws ApiError
 */
const postResendActivationcodeV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/consumer/resendonlineaccountactivationcode/v2',
        query: {
            online_account_id: data.onlineAccountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            409: '',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postResendActivationcodeV2 = postResendActivationcodeV2;
/**
 * Unblocks an online account
 * @param data The data for the request.
 * @param data.onlineAccountId Online Account Id of the consumer
 * @param data.requestBody
 * @returns OnlineAccount OK
 * @throws ApiError
 */
const patchUnblockOnlineAccountV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PATCH',
        url: '/consumer/unblockonlineaccount/v2',
        query: {
            online_account_id: data.onlineAccountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            409: '',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.patchUnblockOnlineAccountV2 = patchUnblockOnlineAccountV2;
/**
 * This Service will update the email of an online account based on the given input.
 * @param data The data for the request.
 * @param data.onlineAccountId Online Account Id of the consumer
 * @param data.requestBody
 * @returns OnlineAccount OK
 * @throws ApiError
 */
const patchOnlineAccountV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PATCH',
        url: '/consumer/onlineaccount/v2',
        query: {
            online_account_id: data.onlineAccountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            409: '',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.patchOnlineAccountV2 = patchOnlineAccountV2;
/**
 * This Service retrieves the summary of the online account details.
 * @param data The data for the request.
 * @param data.onlineAccountId Online Account Id of the consumer
 * @returns OnlineAccount OK
 * @throws ApiError
 */
const getOnlineAccountV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/consumer/onlineaccount/v2',
        query: {
            online_account_id: data.onlineAccountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getOnlineAccountV2 = getOnlineAccountV2;
/**
 * This Service reset the password by sending a reset link to the customers email.
 * @param data The data for the request.
 * @param data.onlineAccountId Online Account Id of the consumer
 * @param data.requestBody
 * @param data.contactlogId The contact log identifier
 * @returns void OK
 * @throws ApiError
 */
const postResetOnlineAccountPasswordV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/consumer/resetonlineaccountpassword/v2',
        query: {
            online_account_id: data.onlineAccountId,
            contactlog_id: data.contactlogId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            409: '',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postResetOnlineAccountPasswordV2 = postResetOnlineAccountPasswordV2;
/**
 * This Service reset the password by sending a reset link to the customers email.
 * @param data The data for the request.
 * @param data.onlineAccountId Online Account Id of the consumer
 * @param data.requestBody
 * @returns void OK
 * @throws ApiError
 */
const patchChangeOnlineAccountPasswordV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PATCH',
        url: '/consumer/changeonlineaccountpassword/v1',
        query: {
            online_account_id: data.onlineAccountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            409: '',
            410: 'gone',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.patchChangeOnlineAccountPasswordV1 = patchChangeOnlineAccountPasswordV1;
